module.exports = __webpack_public_path__ + "media/images/exp-thumb3-sm-282d11da53938cefffb94d44f71b66af.png";